import { Icon } from "armstrong-react";
import React from "react";
import * as WebRoutes from "@travellocal/utils/webRoutes";
import { FlexiCard } from "./flexiCard";

export class UpsellCard extends React.PureComponent<{}, {}> {
  private renderDirectToExperts = () => {
    return (
      <FlexiCard
        className="cta-card"
        icomoon={Icon.Icomoon.bubbles3}
        title="Direct to local experts"
        description="When you send an enquiry with TravelLocal, we put you directly in touch with our local travel experts in your chosen country. They'll work with you to create your perfect tailor-made holiday."
        cta="Find out more"
        to={WebRoutes.aboutHowItWorks()} />
    );
  }

  private renderTailorMade = () => {
    return (
      <FlexiCard
        className="cta-card"
        icomoon={Icon.Icomoon.map2}
        title="Tailor-made for you"
        description="Our local experts do their best to ensure that your tailor-made holiday is exactly what you want. Refine your itinerary to your heart's content to make it perfect for you."
        cta="Find out more"
        to={WebRoutes.aboutHowItWorks()} />
    );
  }

  private renderLocalKnowledge = () => {
    return (
      <FlexiCard
        className="cta-card"
        icomoon={Icon.Icomoon.map}
        title="Local knowledge"
        description="All of TravelLocal's experts are based in their own country. Their local knowledge guarantees you'll get a great itinerary."
        cta="Find out more"
        to={WebRoutes.aboutHowItWorks()} />
    );
  }

  private renderHereForYou = () => {
    return (
      <FlexiCard
        className="cta-card"
        icomoon={Icon.Icomoon.reading}
        title="We're here for you"
        description="The TravelLocal team and our local experts take pride in making sure you have a great holiday. We're on hand for help if you need it."
        cta="Find out more"
        to={WebRoutes.aboutHowItWorks()} />
    );
  }

  public render() {
    const selection = [
      this.renderDirectToExperts,
      this.renderLocalKnowledge,
      this.renderTailorMade,
      this.renderHereForYou,
    ];

    return selection[Math.floor(Math.random() * selection.length)]();
  }
}
